import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./PregledRegistara.css";
import { connect } from "react-redux";

class PregledRegistara extends Component {
  state = {
    formData: [],
  };

  componentDidMount() {}

  getCardHeight() {
    return "120px";
  }

  getCardPadding() {
    return "16px";
  }

  getRowBottomMargin() {
    return "16px";
  }

  render() {

    const { userRole } = this.props;
    const isUserSluzbenik = userRole === "ROLE_SLUZBENIK";
    
    return (
      <>
        <Container className="container_registri">
          <div className="header" style={{ textAlign: "center"}}>
            <div className="title">
              Odaberite registar
            </div>
          </div>
          <Row>
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{ pathname: `/pregled-registra/obrazac/1`, vrOsobe: 1 }}
                >
                  <div className="pregled-card-text">
                    REGISTAR OVLAŠTENIH REVIZORA
                  </div>

                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>
            {isUserSluzbenik && (
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{ pathname: `/pregled-registra/obrazac/4`, vrOsobe: 2 }}
                >
                  <div className="pregled-card-text">
                    REGISTAR REVIZORSKIH VJEŽBENIKA
                  </div>

                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>
            )}
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{ pathname: `/pregled-registra/obrazac/6`, vrOsobe: 3 }}
                >
                  <div className="pregled-card-text">
                    REGISTAR OVLAŠTENIH REVIZORA IZ DRUGIH DRŽAVA ČLANICA
                  </div>
                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{ pathname: `/pregled-registra/obrazac/8`, vrOsobe: 4 }}
                >
                  <div className="pregled-card-text">
                    REGISTAR OVLAŠTENIH REVIZORA IZ TREĆIH ZEMALJA
                  </div>

                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{ pathname: `/pregled-registra/obrazac/2`, vrDrustva: 1 }}
                >
                  <div className="pregled-card-text">
                    REGISTAR REVIZORSKIH DRUŠTAVA
                  </div>

                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{ pathname: `/pregled-registra/obrazac/3`, vrDrustva: 2 }}
                >
                  <div className="pregled-card-text">
                    REGISTAR SAMOSTALNIH REVIZORA
                  </div>

                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{ pathname: `/pregled-registra/obrazac/5`, vrDrustva: 3 }}
                >
                  <div className="pregled-card-text">
                    REGISTAR REVIZORSKIH DRUŠTAVA IZ DRUGIH DRŽAVA ČLANICA
                  </div>

                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>{" "}
            <Col md={6} lg={6} xl={3}>
              <div className="card-container">
                <Link
                  className="card1"
                  to={{
                    pathname: `/pregled-registra/obrazac/7`,
                    vrDrustva: 4,
                    vrOsobe: 5,
                  }}
                >
                  <div className="pregled-card-text">
                    REGISTAR SUBJEKATA ZA OBAVLJANJE REVIZIJE U TREĆOJ ZEMLJI I
                    REGISTAR REVIZORA U TREĆOJ ZEMLJI
                  </div>

                  <div className="go-corner" href="#">
                    <div className="go-arrow">→</div>
                  </div>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const userData = state?.authentication?.userData;
  const userRole = userData?.roles?.[0]?.roleName ?? "";
  return { userRole };
};

export default connect(mapStateToProps)(PregledRegistara);